import EmailExportHtml from '../../app-lite/export/templates/email-export.html';

export function ExportProductsCtrl (
  $scope,
  $uibModalInstance,
  $translate,
  $uibModal,
  $q,
  company,
  messages,
  workshopAPI
) {
  $scope.company = company;

  $scope.options = {
    limit : 0,
    offset : 0
  };

  $scope.export = function (form) {
    return workshopAPI.get('/products/product_csv_export_count', [$scope.company.id, $scope.options.limit, $scope.options.offset]).then(function(count) {
      if (count) {
        $uibModalInstance.close();
        $uibModal.open({
          templateUrl: EmailExportHtml,
          controller: 'emailProductExportCtrl',
          windowClass: 'md-modal',
          resolve: {
            company () {
              return $scope.company;
            },
            limited () {
              return false;
            },
            product_offset () {
              return $scope.options.offset;
            },
            product_limit () {
              return $scope.options.limit;
            }
          }
        }).result;
      }
      else {
        messages.error($translate.instant('JS_SPACE.MESSAGES.NO_ITEM_TO_EXPORT', {data: $translate.instant('PRODUCT_SPACE.PRODUCTS')}), 'error');
        return $q.reject();
      };
    });
  };

  $scope.cancel = $uibModalInstance.dismiss;
}